<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
                <font-awesome-icon class="md-icon" :icon="['fa', 'folder']"/>
            </div>
            <h4 class="title">Rapports d'intervention</h4>
        </md-card-header>
        <md-card-content>
            <div v-if="canGeneratePdf">
                <div>
                    <md-button class="md-icon-button md-raised md-success my-0 mr-3"
                               @click="generatePdf('simple')"
                               :disabled="awaitingRequest">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'sync-alt']" :class="{ 'animate-spin': generating }" />
                        <span class="leading-none font-medium ml-2">Voir le rapport PDF LIVE</span>
                    </md-button>
                    <md-button class="md-icon-button md-raised md-success my-0 mr-3"
                               v-if="intervention.canGeneratePdfWithPlans"
                               @click="generatePdf('complete')"
                               :disabled="awaitingRequest">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'sync-alt']" :class="{ 'animate-spin': generatingWithPlans }" />
                        <span class="leading-none font-medium ml-2">Voir le rapport PDF LIVE (avec plans)</span>
                    </md-button>
                    <md-button class="md-icon-button md-raised md-success my-0 mr-3"
                               @click="getLastVersion"
                               :disabled="reports.length === 0">
                        <span class="leading-none font-medium">Voir le rapport PDF fixe</span>
                    </md-button>
                    <md-button class="md-icon-button md-raised md-success my-0 mr-3"
                               @click="storePdf"
                               :disabled="awaitingRequest">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'sync-alt']" :class="{ 'animate-spin': storing }" />
                        <span class="leading-none font-medium ml-2">Regénérer le rapport</span>
                    </md-button>
                </div>
                <div v-if="reports.length > 0">
                    <h6 class="mt-3">Versions existantes du rapport</h6>
                    <ul>
                        <li v-for="(report, key) in reports" :key="key"><a :href="report.url" target="_blank">{{ report.name }}</a></li>
                    </ul>
                </div>
                <div v-else>
                    Pas de rapport stocké pour cette intervention
                </div>
            </div>
            <div v-else>
                Vous devez créer un rapport d'intervention et une signature pour générer un rapport PDF
            </div>
        </md-card-content>
    </md-card>
</template>

<script>
export default {
    name: "PdfReports",
    props: {
        intervention: Object
    },
    data () {
        return {
            generating: false,
            generatingWithPlans: false,
            storing: false,
            reports: []
        }
    },
    computed: {
        canGeneratePdf() {
            // Check if pdf report can be generated (report exists in database, has a model value, model value is not from V1, and has a signature)
            return this.intervention.report && (this.intervention.report.model_value && JSON.parse(this.intervention.report.model_value).madate === undefined) && this.intervention.report.report_signature !== null
        },
        awaitingRequest () {
            return this.generating || this.generatingWithPlans || this.storing
        }
    },
    async mounted () {
        if (this.intervention.report) {
            const { data } = await this.$store.dispatch('interventionReports/getPdfReports', {
                id: this.intervention.report.id,
            })
            this.reports = data
        }
    },
    methods: {
        async generatePdf (type) {
            if (type === 'complete') {
                this.generatingWithPlans = true
            } else {
                this.generating = true
            }
            const { data } = await this.$store.dispatch('interventionReports/generatePdf', {
                id: this.intervention.id,
                type: type
            })
            let link = document.createElement('a')
            link.setAttribute('href', data)
            link.setAttribute('target', '_blank')
            link.click()
            this.generating = false
            this.generatingWithPlans = false
        },
        getLastVersion () {
            let link = document.createElement('a')
            link.setAttribute('href', this.intervention.report.url)
            link.setAttribute('target', '_blank')
            link.click()
        },
        async storePdf() {
            this.storing = true
            const { data } = await this.$store.dispatch('interventionReports/storePdf', {
                id: this.intervention.id,
            })
            this.reports = data.reports
            this.intervention.report.url = data.url
            await this.$store.dispatch('alerts/success', 'Le fichier PDF a ébien été enregistré')
            this.storing = false
        }
    }

}
</script>

<style scoped>

</style>
